var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconManagerPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "44px",
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\xC4riklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Haldus",
    transform: "translate(-920.000000, -1528.000000)",
    stroke: "#000000",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-3",
    transform: "translate(208.000000, 1473.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bitmap",
    transform: "translate(446.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(32.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22-Copy",
    transform: "translate(176.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(16.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.4380299,12.2175257 C60.160339,10.4921593 60.160339,7.69802899 58.4380299,5.97266265 L53.7529508,1.293311 C52.028456,-0.431103666 49.2325825,-0.431103666 47.5080877,1.293311 L44.9402673,3.86304063 C42.7126417,6.08713259 42.3620197,9.57338529 44.1021459,12.1965249 C51.6641451,23.5787297 61.4222557,33.3368402 72.8044604,40.8988394 C75.4282647,42.6364206 78.9124848,42.2876794 81.1398538,40.0645364 L83.7076743,37.4948067 C84.5362376,36.6669216 85.0017766,35.5436612 85.0017766,34.3723752 C85.0017766,33.2010892 84.5362376,32.0778289 83.7076743,31.2499437 L79.0245043,26.5667737 C78.1966192,25.7382105 77.0733589,25.2726714 75.9020728,25.2726714 C74.7307868,25.2726714 73.6075265,25.7382105 72.7796413,26.5667737 L71.2179483,28.1284668 C65.9846768,23.8217754 61.1816349,19.0174548 56.8763368,13.783037 L58.4380299,12.2175257 Z",
    id: "Path"
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconManagerPhone);
export default __webpack_public_path__ + "static/media/Icon_Manager_Phone.53e44bf3a414fdaac0b346d91456a8dc.svg";
export { ForwardRef as ReactComponent };